import React, { useState , useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ROw, Col, Input, Label } from 'reactstrap';
import { useSelector , useDispatch } from 'react-redux';
import CreatableSelect from 'react-select/creatable';

//import images
import avatar1 from '../../../assets/images/users/avatar-1.jpg';
import { CREATE_DASHBOARD, GET_DASHBOARD_CATEGORY, GET_DASHBOARD_CATEGORY_BY_GROUP } from '../../../slices/dashboard/thunk';
import Loader from '../Loader';
import { useNavigate } from 'react-router-dom';
import { fileToBase64 } from '../../../slices/layouts/utils';



const Create_New_Dashboard = ({}) => {
    const {  Group_List   }  = useSelector((state)=>state.Create_Bot)
    const { dashboard_loader , dashboard_category_by_group } = useSelector((state)=>state.Dashboard)
    const [user_avatar, setuser_avatar] = useState(null)
    const [group_id, set_group_id] = useState(null)
    const [dashboard_name, set_dashboard_name] = useState(null)
    const [category, set_category] = useState(null)
    const [description, setdescription] = useState(null)
    const [dashboard_category_list, set_dashboard_category_list] = useState([])
    const [user_avatar_file, setuser_avatar_file] = useState(null)
    const [dashboard_logo, set_dashboard_logo] = useState(null)
    const navigate = useNavigate()
    const dispatch = useDispatch()
   // modal_grid Example
   const [modal_grid, setmodal_grid] = useState(false);
   const [modal_standard, setmodal_standard] = useState(false);
       function tog_standard() {
           setmodal_standard(!modal_standard);
       }


    const onSubmit = ()=>{
        dispatch(CREATE_DASHBOARD({
            dashboard_category: category,
            dashboard_name: dashboard_name,
            dashboarddescription: description,
            group_id: group_id,
            Dashboard_Logo:user_avatar_file
        },navigate))

    }



    useEffect(() => {
      dispatch(GET_DASHBOARD_CATEGORY_BY_GROUP({ group_id }))
    }, [group_id])



    useEffect(() => {
        set_dashboard_category_list(dashboard_category_by_group.map((ele, index)=>{
          return { label:ele.Dashboard_Category , value:ele.Dashboard_Category  }
        }))
    }, [dashboard_category_by_group])
    
    


  

     return (
       <>
         <Button onClick={() => tog_standard()}>Create New Dashboard</Button>
         {/* Grids in Modals */}

         <Modal
           id="myModal"
           isOpen={modal_standard}
           toggle={() => {
             tog_standard();
           }}
         >
           <ModalHeader
             className="modal-title"
             id="myModalLabel"
             toggle={() => {
               tog_standard();
             }}
           >
             Create A New Dashboard
           </ModalHeader>

           <ModalBody>
             {dashboard_loader ? (
               <Loader />
             ) : (
               <form
                 onSubmit={(e) => {
                   e.preventDefault();
                   onSubmit();
                 }}
               >
                 <div className="row g-3">
                   <Col lg={7}>
                     <div className="cnbn">
                       <label htmlFor="botname" className="form-label">
                         Dashboard Name *
                       </label>
                       <Input
                         required={true}
                         value={dashboard_name}
                         onChange={(e) => set_dashboard_name(e.target.value)}
                         type="text"
                         className="form-control"
                         id="firstName"
                         placeholder=""
                       />
                     </div>
                   </Col>
                   <Col lg={5}>
                     <div className="text-center">
                       <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                         <img
                           src={user_avatar || avatar1}
                           className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                           alt="user-profile"
                         />
                         <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                           <Input
                             name="profile_image"
                             id="profile-img-file-input"
                             type="file"
                             className="profile-img-file-input"
                             accept=".jpg,.jpeg,.png"
                             onChange={async (e) => {
                               const file = e.target.files[0];
                               const allowedTypes = [
                                 "image/jpeg",
                                 "image/jpg",
                                 "image/png",
                               ];

                               if (file && allowedTypes.includes(file.type)) {
                                //  console.log("File accepted for profile");
                                 setuser_avatar(URL.createObjectURL(file));
                                //  console.log(file)
                                 setuser_avatar_file(file)
                                 
                                 const blob = await fileToBase64(file);
                                 const blobString = JSON.stringify(blob);

                                 set_dashboard_logo(blobString);
                               } else {
                                 alert(
                                   "Please upload a valid JPG or PNG file."
                                 );
                                 e.target.value = null; // Reset the input
                               }
                             }}
                           />
                           <Label
                             htmlFor="profile-img-file-input"
                             className="profile-photo-edit avatar-xs"
                           >
                             <span className="avatar-title rounded-circle bg-light text-body">
                               <i className="ri-camera-fill"></i>
                             </span>
                           </Label>
                         </div>
                       </div>
                     </div>
                   </Col>

                   <Col className="mt-1" lg={6}>
                     <label htmlFor="llm_model" className="form-label">
                       Group *
                     </label>
                     <select
                       required={true}
                       onChange={(e) => {
                         set_group_id(e.target.value);
                       }}
                       className="form-select"
                       aria-label=".form-select-sm example"
                       value={group_id}
                     >
                       <option value="" disabled selected>
                         Select a group
                       </option>
                       {Group_List.map((ele, i) => (
                         <option key={i} value={ele.Group_ID}>
                           {ele.Group_Name}
                         </option>
                       ))}
                     </select>
                   </Col>
                   <Col className="mt-0" lg={6}>
                     <label htmlFor="llm_model" className="form-label">
                       Category *
                     </label>
                     <CreatableSelect
                       required={true}
                       //   isDisabled={(User_Role ==='BotUser' || User_Role ==='Viewer' )}
                       placeholder="Create or Select"
                       onChange={(value) => {
                         set_category(value.value);
                       }}
                       defaultInputValue={""}
                       options={dashboard_category_list}
                     />
                   </Col>

                   <Col lg={12}>
                     <div>
                       <label htmlFor="description" className="form-label">
                         Description{" "}
                       </label>
                       <textarea
                         onChange={(e) => {
                           setdescription(e.target.value);
                         }}
                         className="form-control"
                         id="botdescription"
                         rows="5"
                       ></textarea>
                     </div>
                   </Col>
                   <Col lg={12}>
                     <div className="hstack gap-2 justify-content-center">
                       <Button color="light">Cancel</Button>
                       <Button type="submit">Next</Button>
                     </div>
                   </Col>
                 </div>
               </form>
             )}
           </ModalBody>
         </Modal>
       </>
     );
}

export default Create_New_Dashboard
